import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-798b75de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cocacola-s5-modal-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "d-none d-sm-block",
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.72516 37.5467L0.660156 35.4817L16.9935 19.1483L0.660156 2.815L2.72516 0.75L19.0585 17.0833L35.3918 0.75L37.4568 2.815L21.1235 19.1483L37.4568 35.4817L35.3918 37.5467L19.0585 21.2133L2.72516 37.5467Z",
    fill: "#F40000"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "d-sm-none",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.86577 18.1909L6.19531 17.5204L11.4983 12.2174L6.19531 6.91435L6.86577 6.2439L12.1688 11.5469L17.4718 6.2439L18.1423 6.91435L12.8393 12.2174L18.1423 17.5204L17.4718 18.1909L12.1688 12.8878L6.86577 18.1909Z",
    fill: "#F40000"
  })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "cocacola-s5-modal-title cola-color" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "cocacola-s5-modal-footer" }

import { onBeforeUnmount, onMounted } from 'vue';

interface Props {
  title?: string;
  modelValue: boolean;
  clickOverlayCancel?: boolean;
  showClose?: boolean;
  escCancel?: boolean;
}

interface Emits {
  (event: 'update:model-value', val: boolean): void;
  (event: 'opened'): void;
  (event: 'closed'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: { type: Boolean },
    clickOverlayCancel: { type: Boolean, default: true },
    showClose: { type: Boolean, default: true },
    escCancel: { type: Boolean, default: true }
  },
  emits: ["update:model-value", "opened", "closed"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: boolean): void;
  (event: 'opened'): void;
  (event: 'closed'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title?: string, modelValue: boolean, clickOverlayCancel: boolean, showClose: boolean, escCancel: boolean }




const onClickOverlay = () => {
  if (props.clickOverlayCancel) {
    onClose();
  }
};

function onClose() {
  emits('update:model-value', false);
}

const popupId = `${Date.now()}-${Math.random().toFixed(4)}`;
const lockBodyClass = `popup-body-lock-${popupId}`;

function onEnter() {
  document.body.classList.add(lockBodyClass);
}

function onLeave() {
  document.body.classList.remove(lockBodyClass);
}

function onEsc(event: KeyboardEvent) {
  if (event.key === 'Escape' || event.keyCode === 27) {
    if (props.escCancel) {
      onClose();
    }
  }
}

onMounted(() => {
  document.addEventListener('keydown', onEsc);
});

onBeforeUnmount(() => {
  onLeave();
  document.removeEventListener('keydown', onEsc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "modal-fade",
    onAfterEnter: _cache[1] || (_cache[1] = ($event: any) => (emits('opened'))),
    onAfterLeave: _cache[2] || (_cache[2] = ($event: any) => (emits('closed'))),
    onEnter: onEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cocacola-s5-modal",
            onClick: onClickOverlay
          }, [
            _createElementVNode("div", {
              class: "cocacola-s5-modal-body",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              (__props.showClose)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                      class: "button-close",
                      onClick: onClose
                    }, _hoisted_4)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["cocacola-s5-modal-content", { 'title-only': !_ctx.$slots.default }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "title", {}, () => [
                    (__props.title)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "text-20",
                          innerHTML: __props.title
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _renderSlot(_ctx.$slots, "default")
              ], 2),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "footer")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})